import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { ReportLabel } from '@ulysses-inc/harami_api_client'
import { ImageSection } from './ImageSection'
import { StatusDisplay } from './StatusDisplay'

const styles = StyleSheet.create({
  section: {
    paddingLeft: 10,
    width: '100%',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10,
    width: '100%',
  },
  divider: {
    borderLeft: '1px solid #000000',
    height: '100%',
    width: 0.5,
  },
  leftColumn: {
    width: '100%',
    maxWidth: 140,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  rightColumn: {
    width: '100%',
    maxWidth: 140,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  imageWrapper: {
    aspectRatio: 1,
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderColor: '#CCCCCC',
  },
  name: {
    textAlign: 'left',
    paddingTop: 5,
  },
})

type LabelItemProps = {
  labelResult: ReportLabel
}

export const LabelItem = ({ labelResult }: LabelItemProps) => {
  return (
    <View key={labelResult.labelId} style={styles.section} wrap={false}>
      <View style={styles.container}>
        {/* 左側：見本画像 */}
        <View style={styles.leftColumn}>
          <ImageSection
            imageUrl={labelResult.sampleImageUrl}
            placeholder="画像なし"
            wrapperStyle={styles.imageWrapper}
          />
          <View>
            <Text style={styles.name}> {labelResult.name}</Text>
          </View>
        </View>

        <View style={styles.divider} />

        {/* 右側：検査画像 + 解析結果 */}
        <View style={styles.rightColumn}>
          <View>
            <ImageSection
              imageUrl={labelResult.resultImageUrl}
              placeholder="検査結果なし"
              wrapperStyle={styles.imageWrapper}
            />
            <StatusDisplay areas={labelResult.reportLabelInspectionAreas} />
          </View>
        </View>
      </View>
    </View>
  )
}
